import {defaultInputRanges} from 'react-date-range';


const defaultInputsRangeLocales = (language = "es") => {
    const locales = {
        "es": {
            "days up to today": "Días hasta hoy",
            "days starting today": "Días a partir de hoy",
        }
    }
    if (language !== "en") {
        if (!(language in locales)){
            return defaultInputRanges;
        }
        let i;
        for (i=0; i<defaultInputRanges.length; i++) {
            if(defaultInputRanges[i].locale && defaultInputRanges[i].locale === language){
                break;
            }
            defaultInputRanges[i].label = locales[language][defaultInputRanges[i].label];
            defaultInputRanges[i].locale = language;
        }
    }
    return defaultInputRanges;
}
export default defaultInputsRangeLocales